import React from "react";
import { Link } from "react-router-dom";
import heroMasjid from "../../../assets/hero_masjid.jpg";
import PublicHeader from "../../components/PublicHeader";
import PublicFooter from "../../components/PublicFooter";
import SharedWhatsAppAiButton from "../../../app/components/SharedWhatsAppAiButton";
import { PUBLIC_REGISTRATION_ENABLED } from "../../../config/features";

export default function PublicHomePage() {
  return (
    <div className="public-layout pp-layout">
      <PublicHeader />

      <main className="flex-grow-1">
        {/* HERO */}
        <section className="pp-hero">
          <img className="pp-hero-bg" src={heroMasjid} alt="Masjid Sultan Salahuddin Abdul Aziz Shah, Shah Alam" />
          <div className="pp-hero-scrim"></div>
          <div className="pp-hero-in">
            <div className="pp-hero-txt">
              <div className="pp-eyebrow">
                <span className="pp-eyebrow-ln"></span>
                <span>SELAMAT DATANG KE</span>
              </div>
              <h1 className="pp-hero-title">
                Sistem Pengurusan<br />Penguatkuasaan Syariah
              </h1>
              <div className="pp-hero-sub">
                Bahagian Pengurusan Penguatkuasaan<br />Jabatan Agama Islam Selangor
              </div>
              <p className="pp-hero-lead">
                Portal rasmi bagi penerimaan aduan, semakan status dan pengurusan
                penguatkuasaan syariah di Negeri Selangor.
              </p>
              <div className="pp-hero-cta">
                <Link to="/semak-status" className="pp-btn pp-btn-solid pp-btn-lg">
                  <i className="bi bi-search"></i> Semak Status Aduan
                </Link>
                {PUBLIC_REGISTRATION_ENABLED && (
                  <Link to="/register" className="pp-btn pp-btn-gold pp-btn-lg">
                    <i className="bi bi-pencil-square"></i> Buat Aduan
                  </Link>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* PERINGATAN MESRA */}
        <section className="pp-section">
          <div className="pp-container">
            <div className="pp-peringatan">
              <div className="pp-peringatan-head">
                <i className="bi bi-exclamation-triangle-fill"></i> PERINGATAN MESRA
              </div>
              <p className="pp-peringatan-sub">
                Sebagaimana merujuk di bawah Seksyen 211, Enakmen Tatacara Jenayah Syariah
                (Negeri Selangor) Tahun 2003 &mdash; Maklumat, keterangan atau pengakuan palsu.
              </p>
              <p className="pp-peringatan-quote">
                &ldquo;Barang siapa yang dengan sengaja memberi apa-apa maklumat, keterangan atau
                pengakuan palsu secara lisan atau bertulis yang palsu dalam apa-apa perkara jika dia
                dikehendaki memberi maklumat, keterangan atau pengakuan sedemikian oleh peruntukan
                Enakmen ini adalah melakukan kesalahan dan apabila disabitkan boleh didenda tidak
                melebihi dua ribu ringgit atau dipenjarakan selama tempoh tidak melebihi satu tahun
                atau kedua-duanya sekali.&rdquo;
              </p>
            </div>
          </div>
        </section>

        {/* CIRI / PERKHIDMATAN */}
        <section className="pp-section pp-section-cream">
          <div className="pp-container">
            <div className="pp-features">
              {PUBLIC_REGISTRATION_ENABLED && (
                <div className="pp-card">
                  <div className="pp-card-icon"><i className="bi bi-pencil-square"></i></div>
                  <h3>Daftar Untuk Buat Aduan</h3>
                  <p>Orang awam boleh mendaftar dan membuat aduan penguatkuasaan syariah secara atas talian.</p>
                  <Link to="/register" className="pp-card-link">Daftar sekarang <i className="bi bi-arrow-right"></i></Link>
                </div>
              )}
              <div className="pp-card">
                <div className="pp-card-icon"><i className="bi bi-search"></i></div>
                <h3>Semak Status Aduan</h3>
                <p>Semak perkembangan dan status tindakan aduan anda dengan nombor rujukan.</p>
                <Link to="/semak-status" className="pp-card-link">Semak status <i className="bi bi-arrow-right"></i></Link>
              </div>
              <div className="pp-card">
                <div className="pp-card-icon"><i className="bi bi-shield-check"></i></div>
                <h3>Pengurusan JAIS</h3>
                <p>Setiap aduan diurus sepenuhnya oleh pegawai penguatkuasaan JAIS secara sistematik dan sulit.</p>
                <span className="pp-card-link pp-card-link-muted">Dikendalikan pegawai bertauliah</span>
              </div>
            </div>
          </div>
        </section>
      </main>

      <PublicFooter />
      <SharedWhatsAppAiButton />
    </div>
  );
}
